let changeChatInfo = (state, { payload }) => {
    state.currentChat.image = payload.image ? payload.image : state.currentChat.image;
    state.currentChat.name = payload.name ? payload.name : state.currentChat.name;
};

export default changeChatInfo;
